import Vue from 'vue';
import Vuex from 'vuex';

import settings from './dashboard/settings.js';
import user from './dashboard/user.js';
import cache from './dashboard/cache.js';
import realtimeio from './dashboard/realtimeio.js';
import message from './dashboard/message.js';
import marketing from './dashboard/marketing';
import dashboard from './dashboard/dashboard.js';
import event from './dashboard/event.js';
import extensionio from './dashboard/extensionio';
import block from './dashboard/block.js';
import transaction from './dashboard/transaction.js';
import undo from './dashboard/undo.js';

import http from '@/lib/http.js';
import api from '@/lib/api.js';

Vue.use(Vuex);

let url = 'http://localhost:4000'; //"https://api.underlineme.com";

if (process.env.NODE_ENV === 'production') {
	url = 'https://api.underlineme.com';
}

window.url = url;

let store = new Vuex.Store({
	state: {
		init: false, // only becomes true when auth has been resolved
		loaded: false, // only becomes true when all data has been loaded initially. Subsequent network requests won't flip this state
		firstRun: true,
		afterSignup: false,
		pages: [
			{
				name: 'Main',
				route: '/'
			}
		],
		packageVersion: process.env.PACKAGE_VERSION || '0',
		mode: '',
		baseUrl: url,
		dataTransfer: null,
		isDemo: false
	},
	getters: {
		init: function(state) {
			return state.init;
		},
		loaded: function(state) {
			return state.loaded;
		},
		mode: function(state) {
			return state.mode;
		},
		afterSignup: function(state) {
			return state.afterSignup;
		},
		version: function(state) {
			return state.packageVersion;
		},
		production: function() {
			if (typeof webpackHotUpdate !== 'undefined') {
				return false;
			} else {
				return true;
			}
		},
		isDemo: function(state) {
			return state.isDemo;
		},
		isWidget: function() {
			if (window.location !== window.parent.location) {
				return true;
			} else {
				return false;
			}
		}
	},
	mutations: {
		SET_SETTINGS: function(state, settings) {
			state.settings = settings;
		},
		SET_MODE: function(state, mode) {
			state.mode = mode;
		},

		SET_FIRST_RUN: function(state) {
			state.firstRun = false;
		},
		SET_AFTER_SIGNUP: function(state) {
			state.afterSignup = true;
		},
		SAVE_ID: function(state, id) {
			state.id = id;
			saveProperty({
				id: id
			});
		},
		SET_ID: function(state, id) {
			state.id = id;
		},
		SET_LOADED: function(state, action) {
			state.loaded = action;
		},
		SET_DATATRANSFER: function(state, data) {
			state.dataTransfer = data;
		},
		SET_DEMO: function(state, isDemo) {
			state.isDemo = isDemo;
		}
	},
	actions: {
		async setSession(store) {
			// let sessionId = await api.app.getSession();
			// if (!sessionId) {
			// 	sessionId = createId();
			// 	api.app.setSession(sessionId);
			// }
		},
		async init(store) {
			if (typeof chrome !== 'undefined' && chrome.permissions) {
				window.mode = 'EXTENSION';
				window.browser = require('webextension-polyfill');
			} else {
				window.mode = 'LOCAL';
				//window.mode = 'WEBAPP';
			}
			store.commit('SET_MODE', window.mode);

			await api.init();

			http.setContext(store);
			http.setUrl(store.state.baseUrl);
			store.dispatch('cache/init');
			await store.dispatch('user/init');
			store.dispatch('settings/getUiState');
			await store.dispatch('setSession');
			store.dispatch('transaction/init');
			store.dispatch('event/init');
			let isAuth = store.getters['user/isAuth'];
			store.state.init = true;

			if (mode === 'EXTENSION') {
				store.dispatch('extensionio/setupEventListeners');
			}
			if (isAuth) {
				await store.dispatch('afterLogin');
			} else {
				await store.dispatch('setData');
			}

			return isAuth;
		},
		async afterAuth(store) {
			await store.dispatch('afterLogin');
		},
		async afterLogin(store) {
			if (mode === 'WEBAPP') {
				await store.dispatch('realtimeio/setupEventListeners');
			}
			await store.dispatch('extensionio/signal', 'user:login');
			await store.dispatch('setData');
			store.dispatch('event/afterUserLogin');
			store.commit('SET_LOADED', true);
			return true;
		},
		afterLogout: function(store) {
			if (mode === 'WEBAPP') {
				store.dispatch('realtimeio/disconnect');
			}
		},
		async setData(store) {
			await store.dispatch('setAuthorizationHeader');
			await store.dispatch('block/init');
			await store.dispatch('dashboard/init'); // order matters. dashboard should be called last
			await store.dispatch('marketing/init');
			return true;
		},
		async setAuthorizationHeader(store) {
			http.setHeader('Authorization', `Bearer ${store.getters['user/token']}`);
			return true;
			a;
		},
		async setDataTransfer(store, data) {
			if (data.type === 'dragend') {
				window.parent.postMessage({ type: 'drop:received' }, '*');
			}
			if (data.type === 'init') {
				store.commit('SET_DEMO', data.isDemo || false);
			}
			store.commit('SET_DATATRANSFER', data);
		},
		setMode: function(store, mode) {
			store.commit('SET_MODE', mode);
			store.commit('dashboard/TOGGLE_SIDEBAR', false);
		}
	},
	modules: {
		user,
		settings,
		cache,
		marketing,
		realtimeio,
		message,
		dashboard,
		event,
		extensionio,
		block,
		transaction,
		undo
	}
});

export default store;
